/* ------------------------------------------- */
/*   Queries for relationships lookup
/* ------------------------------------------- */

import { AppConfig } from 'AppSrc/core/config/app-config';
import { getRESTQuery, postRESTQuery } from 'AppSrc/core/queries/axios-queries';
import { MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';

const searchIncidents = (network, queryString) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.relationships.incidents}`;
  const params = {
    network,
    id: queryString, // search query sent as (partial) id
  };
  return getRESTQuery(endpoint, params)
    .then((response) => response.data.results);
};

const searchConfigItems = (network, queryString) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.relationships.configItems}`;
  const params = {
    network,
    name: queryString, // search query sent as (partial) name
  };
  return getRESTQuery(endpoint, params)
    .then((response) => response.data.results);
};

const searchProjects = (network, queryString) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.relationships.projects}`;
  const params = {
    network,
    name: queryString, // search query sent as (partial) name
  };
  return getRESTQuery(endpoint, params)
    .then((response) => response.data.results);
};

const postRelationship = (relationship, crqId) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.relationships.create}`;
  const params = {
    network: MOBILE, // relationships are always on mobile
    relationship: {
      id: relationship.id,
      crq_id: crqId,
      name: relationship.name,
      type: relationship.type,
      status: relationship.status,
      reference_type: relationship.referenceType,
      reference_id: relationship.referenceId,
      ua_type: relationship.uaType,
      ua_scheduled_start_date: relationship.uaScheduledStartDate,
      ua_scheduled_end_date: relationship.uaScheduledEndDate,
      reconcilation_id: relationship.reconcilationId, // fixed for uat defect CI's & Node CI's in ACE
      actual_end_date: relationship.actual_end_date,
      actual_start_date: relationship.actual_start_date,
    },
  };
  return postRESTQuery(endpoint, params)
    .then((response) => response.data);
};

const deleteRelationship = (relationshipId, crqId) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.relationships.delete}`;
  const params = {
    network: MOBILE, // relationships are always on mobile
    crq_id: crqId,
    id: relationshipId,
  };
  return postRESTQuery(endpoint, params)
    .then((response) => response.data);
};

export {
  searchIncidents,
  searchConfigItems,
  postRelationship,
  searchProjects,
  deleteRelationship,
};
